import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import jaLocale from 'element-ui/lib/locale/lang/ja';


const messages = {
  en: {
    ...enLocale
  },
  zh: {
    label: {
      interview_id: '面试编码：',
      student_nickname: '学生姓名：',
      accept_time: '接收时间：',
      create_time: '创建时间：',
      sent_time: '发送时间：',
      interview_time: '面试时间：',
      interview_result: '面试结果：',
      certificate: '合格证：',
      interview_in_progress: '是否排期：',
      interview_way: '面试方式：',
      interview_progress: '面试进度：',
      is_sent: '是否发送：',
      sent_school: '发送校方：',
      language_school: '语言学校：',
      term: '学期：',
      is_canceled: '是否取消：',
      apply_school: '申请学校',
      consult_name: '咨询姓名'
    },
    form: {
      reset: '重置',
      search: '搜索',
    },
    tab: {
      今日面试: '今日面试',
      明日面试: '明日面试',
      待排期: '待排期',
      待面试: '待面试',
      待确认结果: '待确认结果',
      待上传合格证: '待上传合格证',
    },
    message: {
      logout: '退出',
      系统视频面试: '系统视频面试',
      系统语音面试: '系统语音面试',
      set_interview_success: '设置面试时间成功',
      面试结果: '面试结果',
      面试方式: '面试方式',
      合格证: '合格证',
      面试结果确认: '面试结果确认',
      合格条件: '合格条件',
      请您填写合格的条件: '请您填写合格的条件',
      点击上传: '点击上传',
      请您填写备注: '请您填写备注',
      关闭: '关闭',
      保存: '保存',
      保存面试结果成功: '保存面试结果成功',
      取消: '取消',
      确认: '确认',
      该时间可以正常预约: '该时间可以正常预约',
      somebody_apply_interview: '{nickname}同学，申请面试',
      报名表: '报名表',
      发送校方: '发送校方',
      取消面试: '取消面试',
      排期确认: '排期确认',
      finish_interview: '要现在结束面试吗？',
      选择日期: '选择日期',
      change_interview_way: '您选择的是“{way}” 确认后将无法修改面试方式，请您确认',
      语音面试: '语音面试',
      等待通讯中: '等待通讯中',
      视频通讯中: '视频通讯中',
      面试已进行: '面试已进行',
      结束: '结束',
      结束面试: '结束面试',
      面试状态: '面试状态',
      修改面试状态: '修改面试状态',
      修改面试状态成功: '修改面试状态成功',
      面试采集表: '面试采集表'
    },
    ...zhLocale
  },
  ja: {
    label: {
      interview_id: '面接番号：',
      student_nickname: '名前：',
      create_time: '创建时间：',
      sent_time: '送信時間：',
      interview_time: 'インタビュー時間：',
      interview_result: 'インタビュー結果：',
      certificate: '合格証明書',
      interview_in_progress: 'スケジュール',
      interview_way: 'インタビュー方法：',
      interview_progress: 'インタビューの進行状況：',
      is_sent: '送るかどうか：',
      sent_school: '学校を送る：',
      language_school: '語学学校：',
      term: '学期：',
      is_canceled: '面接キャンセル：',
    },
    form: {
      reset: 'リセット',
      search: '検索',
    },
    tab: {
      今日面试: '本日面接予定',
      明日面试: '明日面接予定',
      待排期: '手配待受',
      待面试: '待面接',
      待确认结果: '結果未定',
      待上传合格证: '合格証明書アップロード待ち',
      合格证: '合格证',
    },
    message: {
      logout: '終了する',
      系统视频面试: 'ビデオ電話',
      系统语音面试: '電話',
      set_interview_success: '设置面试时间成功',
      面试结果: '面接結果',
      面试方式: '面接方法',
      合格证: '合格証明書',
      面试结果确认: '面接結果確認',
      合格条件: '合格条件',
      请您填写合格的条件: '请您填写合格的条件',
      点击上传: 'アップロード',
      请您填写备注: '備考記入',
      关闭: '閉じる',
      保存: '保存',
      保存面试结果成功: '面接結果保存成功',
      取消: 'キャンセル',
      确认: '確認',
      该时间可以正常预约: '予約できます',
      somebody_apply_interview: '{nickname}さん、面接を申請します',
      报名表: '申請書',
      发送校方: '学校へ送信',
      取消面试: '面接キャンセル',
      排期确认: '排期确认',
      finish_interview: 'すぐ面接を終わらせますか？',
      选择日期: '日にち選択',
      change_interview_way: '「{way}」選択中、確定できたら変更できないので、ご注意ください',
      语音面试: '電話',
      等待通讯中: '等待通讯中',
      视频通讯中: 'ビデオ面接中',
      面试已进行: '面接中',
      结束: '終了',
      结束面试: '面接終了',
    },
    面试管理: '面接管理',
    系统管理: 'システム管理',
    修改密码: 'パスワード変更',
    消息提醒: '状態通知',
    状态提醒: '状態通知',
    学生昵称: '学生ネットネーム',
    生成时间: '作成時間',
    查询: '査問',
    全部标记已读: '全部既読表記',
    消息类型: '情報種類',
    操作: '創作',
    旧密码: '元パスワード',
    新密码: '新パスワード',
    确认密码: 'パスワード確認',
    确认修改: '変更を確認',
    ...jaLocale
  }
};

export default messages;
